import { createApi } from '@reduxjs/toolkit/query/react'
import { MANAGE_TEAM_ADD, MANAGE_TEAM_DELETE, MANAGE_TEAM_LIST, } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const teamApi = createApi({
    reducerPath: 'teamApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/teams",
    }),
    tagTypes: ["TeamList"],
    endpoints: (builder) => ({

        // get team list
        getTeamList: builder.query({
            query: ({ search = "", status = "", page = 1, limit = 10, sort = { column: "id", direction: "DESC" } }) => {
                return ({
                    method: "PATCH",
                    url: MANAGE_TEAM_LIST,
                    data: { search, page, limit, status, sort, }
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["TeamList"]
        }),

        // add team member
        addTeamMember: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: MANAGE_TEAM_ADD,
                data
            }),
            invalidatesTags: ["TeamList"]
        }),

        // remove team member
        deleteTeamMember: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${MANAGE_TEAM_DELETE}/${id}`
            }),
            invalidatesTags: ["TeamList"]
        }),
    }),
})

export const {
    useGetTeamListQuery,
    useAddTeamMemberMutation,
    useDeleteTeamMemberMutation
} = teamApi;